@for (item of stack(); track item.toast) {
  <onyx-toast
    animate.enter="entering"
    animate.leave="leaving"
    [intent]="item.toast.intent"
    [icon]="item.toast.icon"
    [message]="item.toast.message"
    [description]="item.toast.description"
    [buttons]="item.toast.buttons"
    [layout]="item.layout"
    [paused]="isPaused()"
    (heightChange)="setHeight(item.toast, $event)"
    (closeToast)="config.hideToast(item.toast)"
  ></onyx-toast>
}
